<template>
  <div class="no_data">
    <span class="no_data_text">暂无数据……</span>
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  },
}
</script>

<style>
.no_data{
  width: 100%;
  height: 80px;
  font-size: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>


// WEBPACK FOOTER //
// src/components/noData.vue